import type React from "react";
import StreamOverviewCard from "./StreamOverviewCard";
import type { IStreamDetails } from "../../../../types/streams";

interface OverviewTabProps {
  stream: IStreamDetails;
  streamId?: number;
  refreshTrigger?: number;
  onReadyDownload?: (fn: () => void) => void;
}

const OverviewTab: React.FC<OverviewTabProps> = ({
  stream,
  streamId,
  refreshTrigger,
  onReadyDownload,
}) => (
  <StreamOverviewCard
    stream={stream}
    streamId={streamId}
    refreshTrigger={refreshTrigger}
    onReadyDownload={onReadyDownload}
  />
);

export default OverviewTab;
